import React from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';



function Header() {

    const navigate = useNavigate()

    const handleLogin = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('useuserId');

        navigate('/login')
    }




    return (
        <div>

            <nav id='hc' class="navbar navbar-expand-lg navbar-light ">
                <div class="container-fluid">
                    <Link class="navbar-brand" to="/"><i>Blogging</i></Link>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNav">
                        <ul class="navbar-nav justify-content-center ">
                            {/* <li class="nav-item">
                                <Link class="nav-link active" aria-current="page" to="/">Home</Link>
                            </li> */}


                            {
                                (!localStorage.getItem('token')) ?

                                    <div className='navbar-nav'>
                                       
                                       <li class="nav-item ">
                                            <Link id='nn' class="nav-link" to="/login">Login</Link>
                                        </li>

                                        <li class="nav-item ">
                                            <Link id='nn' class="nav-link" to="/create">SignUp</Link>
                                        </li>
                                      
                                    </div>



                                    :

                                    <div className='navbar-nav'>

                                        <li class="nav-item ">
                                        <Link id='n' onClick={handleLogin} class="nav-link" to="#">LogOut</Link>
                                        </li>

                                        <li class="nav-item ">
                                           
                                            <Link id='nn' class="nav-link" to="/post">CreatPost</Link>
                                        </li>

                                        <li class="nav-item ">
                                            <Link id='nn' class="nav-link" to="/userPost">MyPost</Link>
                                        </li>


                                    </div>






                            }





                            {/* <li class="nav-item">
                                <Link class="nav-link" to="/post">Post</Link>
                            </li> */}

                            {/* <li class="nav-item">
                               
                            </li> */}

                            <li class="nav-item">
                                <Link id='nn' class="nav-link" to="/allPost">AllPost</Link>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>

        </div>
    )
}

export default Header
